import { render, staticRenderFns } from "./_sso-error.vue?vue&type=template&id=4853c519"
import script from "./_sso-error.vue?vue&type=script&lang=js"
export * from "./_sso-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports